import {put, takeLatest, call} from 'redux-saga/effects';
import * as productTypeService from "../../../../services/productTypeService";
import {
    ADD_PRODUCT_TYPE,
    ADD_PRODUCT_TYPE_SUCCESS,
    ADD_PRODUCT_TYPE_ERROR
}
    from "../../../actions/menu/productTypes";

function* addProductTypeSaga(action) {
    try {
        const data =  yield call(productTypeService.AddProductType, action.payload)
        yield put({
            type: ADD_PRODUCT_TYPE_SUCCESS,
            payload: data
        });

    } catch (error) {
        yield put({
            type: ADD_PRODUCT_TYPE_ERROR,error: error.data
        });
    }
}


export function* addProductTypeSagaWatcher() {
    yield takeLatest(ADD_PRODUCT_TYPE, addProductTypeSaga);
}